import { useMemo } from 'react';

import { usePlayerStore } from '@air/component-player';

import { type Chapter } from '~/hooks/useAssetVersionChaptersList';
import { normalizeChaptersWithGaps } from '~/utils/normalizeChaptersWithGaps';

/**
 * Returns the chapter list normalized for seekbar rendering: synthetic gap
 * chapters are inserted for any uncovered time ranges so that the full video
 * duration is represented and segment widths are proportionally accurate.
 *
 * Gap chapters (type === 'gap') and real chapter tags are exclusively a seekbar
 * rendering concern.
 */
export const useSeekbarChapters = (chapters: Chapter[] | undefined) => {
  const duration = usePlayerStore((state) => state.duration);

  return useMemo(() => {
    if (!chapters || duration <= 0) {
      return undefined;
    }

    return normalizeChaptersWithGaps(chapters, duration);
  }, [chapters, duration]);
};
